<h2 mat-dialog-title>Schedule Maintenance</h2>
<mat-dialog-content>
    <form [formGroup]="maintenanceForm">
        <div>
            <mat-checkbox formControlName="hip">HIP Maintenance Notification</mat-checkbox>
        </div>
        <div>
            <mat-checkbox formControlName="hicp">HICP Maintenance Notification</mat-checkbox>
        </div>
        <hr>
        <div class="date-wrapper">
            <div class="date-input">
                <p>Start:</p>
                <tools-date-time (notify)="startUpdated($event)"></tools-date-time>
            </div>
            <hr>
            <div class="date-input">
                <p>End:</p>
                <tools-date-time (notify)="endUpdated($event)"></tools-date-time>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Cancel</button>
    <button mat-raised-button (click)="sendMaintenance()">Schedule</button>
</mat-dialog-actions>
